import Vue from 'vue';
import VueGtm from 'vue-gtm';
import router from '@/router/router';

Vue.use(VueGtm, {
  id: import.meta.env.VITE_GTM_ID,
  enabled: true,
  debug: false,
  loadScript: false,
  vueRouter: router,
});
